import axios from 'axios'
import { apiUrl } from '@/config'
import store from '../store'

const request = {
  // Error authentication
  CATCH_ERROR_401: false,
  CATCH_ERROR_403: false,

  init() {
    // Default
    axios.defaults.baseURL = apiUrl
    const headers = {
      Accept: 'application/json',
      'X-Platform-Request': 'web',
      'X-Timezone-Request': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'X-Language-Request': store.getters['app/locale']
    }
    // Set default header
    Object.keys(headers).forEach((key) => {
      axios.defaults.headers.common[key] = headers[key]
    })
    axios.interceptors.response.use(
      (response) => {
        return response.data
      },
      async (error) => {
        if (process.env.NODE_ENV === 'development') {
          window.debugRequestError = error
        }
        let err = {
          success: false,
          status_code: 400,
          message: 'Something went wrong',
          errors: {}
        }
        if (error.response) {
          const statusCode = error.response.data.status_code || 400
          if ((error.response.status === 401 || statusCode === 401) && request.isCatchError(401)) {
            await store.dispatch('auth/logout')
          } else if (error.response.status === 403 || statusCode === 403) {
            await store.dispatch('auth/limitAccess')
          } else if (error.response.status === 404 || statusCode === 404) {
            window.location.replace('/404')
          } else if (error.response.status === 500 && statusCode === 500) {
            window.location.replace('/500')
          }
          if (error.response.data) {
            err = {
              ...err,
              ...error.response.data
            }
          }
          store.dispatch('alert/error', err)
        }
        throw error
      }
    )
  },

  isCatchError(error) {
    return request[`CATCH_ERROR_${error}`]
  },

  setCatchError(error, status) {
    request[`CATCH_ERROR_${error}`] = status
  },

  setAuthHeader() {
    const token = store.getters['auth/token']
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  },

  removeAuthHeader() {
    axios.defaults.headers.common.Authorization = undefined
  },

  get(resource) {
    return axios.get(resource)
  },

  post(resource, data) {
    return axios.post(resource, data)
  },

  put(resource, data) {
    return axios.put(resource, data)
  },

  patch(resource, data) {
    return axios.patch(resource, data)
  },

  delete(resource, data = {}) {
    return axios.delete(resource)
  },

  /**
   * Perform a custom Axios request.
   *
   * config is an object containing the following properties:
   *  - method: get, post, put, delete, patch
   *  - url
   *  - headers: {}, // { 'Content-Type': 'multipart/form-data' }
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  custom(config) {
    return axios(config)
  }
}

export default request
